import { IntlUtilsBase } from './base';
export class IntlUtilsBrowser extends IntlUtilsBase {
    constructor() {
        super(...arguments);
        this.enhanceRouter = (router) => {
            const optimized = this.optimizeRouterPath(router.asPath, router.pathname);
            const genAction = (action) => (url, options) => {
                var _a;
                return router[action](this.revertRouterUrl(url, (_a = options === null || options === void 0 ? void 0 : options.locale) !== null && _a !== void 0 ? _a : optimized.locale), undefined, options);
            };
            return Object.assign(Object.assign(Object.assign({}, router), optimized), { locales: this.languages, push: genAction('push'), replace: genAction('replace') });
        };
        this.revertRouterUrl = (url, locale) => {
            if (!isInternalUrl(url))
                return url;
            const originPathname = getPathnameFromUrl(url);
            const parsedUrl = {};
            parsedUrl.query = typeof url !== 'string' ? Object.assign({}, url.query) : {};
            if (locale !== this.config.defaultLanguage)
                parsedUrl.query[this.config.languageParamName] = locale;
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            else
                delete parsedUrl.query[this.config.languageParamName];
            parsedUrl.pathname = this.revertRouterPathname(originPathname, locale);
            return parsedUrl;
        };
        this.revertRouterPathname = (pathname, locale) => {
            if (!this.isLanguageValid(locale))
                locale = this.config.defaultLanguage;
            if (locale === this.config.defaultLanguage)
                return pathname;
            return `/[${this.config.languageParamName}]${pathname.replace(/\/$/, '')}`;
        };
        this.optimizeRouterPath = (asPath, pathname) => {
            const slug = pathname.split('/')[1];
            if (slug === `[${this.config.languageParamName}]`) {
                const locale = asPath.split('/')[1];
                return {
                    locale,
                    asPath: asPath.replace(`/${locale}`, ''),
                    pathname: pathname.replace(`/${slug}`, ''),
                };
            }
            return {
                locale: this.config.defaultLanguage,
                asPath,
                pathname,
            };
        };
    }
}
const isInternalUrl = (url) => {
    if (typeof url === 'string')
        return url.startsWith('/');
    if (!url.pathname)
        return false;
    return url.pathname.startsWith('/');
};
const getPathnameFromUrl = (url) => {
    return typeof url === 'string' ? url : url.pathname;
};
